module.exports = __webpack_public_path__ + "img/2_1-edificabile.eff01287.png";